import CloseIcon from '@mui/icons-material/Close';
import { DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import CustomInput from '../../../components/CustomInput';
import { ControlpanelPrimaryButton, ControlpanelSecondaryButton, GrayIconButton } from '../../../components/StyledButton';
import { CustomDialog } from '../../../components/StyledComponents';
import { useLoading } from '../../../context/LoadingContext';
import AddBoxIcon from '@mui/icons-material/AddBox';
import { addDepartment } from '../../../axios/Department/DepartmentApi';
import CustomInputHorizontal from '../../../components/CustomInputHorizontal';
import DefaultTooltip from '../../../components/DefaultTooltip';
import QuestionIcon16pxSvg from '../../../assets/images/icons/QuestionIcon16pxSvg';
import { addDesignation } from '../../../axios/Designation/DesignationApi';
import { de } from 'date-fns/locale';

const AddDesignationDialog = (props) => {
   const { onClose, onRefresh } = props;
   const [show, hide] = useLoading();
   const { t } = useTranslation();

   const initialFormData = {
      designationName : '',
      remark: '',
      langId: localStorage.getItem("i18nextLngId")
   };


   const [formData, setFormData] = useState(initialFormData);

   const handleCloseDialog = () => {
      setFormData(initialFormData);
      onClose();
   };


   const updateFormDataAndValidate = (name, value) => {
      if (name === 'departmentPrefix') {
         // Giới hạn 2 ký tự + uppercase
         const trimmedValue = value.toUpperCase().slice(0, 2);

         setFormData((prevData) => ({
            ...prevData,
            [name]: trimmedValue,
         }));
      } else {
         setFormData((prevData) => ({
            ...prevData,
            [name]: value,
         }));
      }
   };

   const handleInputChange = (e) => {
      const { name, value } = e.target;
      updateFormDataAndValidate(name, value);
   };


   const handleSubmit = async (e) => {
         e.preventDefault();
         show()
         try {
            const response = await addDesignation(formData);
            if (response.data.code === 200) {
               const code = response?.data?.data?.responseCode;
               if (code === undefined || code === 0) {
                  handleCloseDialog();
                  toast.success(t('common.add-designation-successfully'));
                  onRefresh();
               } else {
                  toast.error(response.data.data.message)
               }
            } else if (response.data.code === 500) {
               toast.error(response.data.message)
               handleCloseDialog();
            } else {
               toast.error(response.data.data.responseCode ? response.data.data.message : response.data.data.fieldErrors[0]?.message)
            }
         } catch (error) {
            if (error.response) {
               if (error.response.status !== 401) {
                  toast.error(t(error?.response.data));
               }
            } else {
               toast.error(t('common.network-timeout'));
            }
         } finally {
            hide()
         }
      };

   return (
      <CustomDialog maxWidth={'sm'} open onClose={handleCloseDialog} keepMounted>
         <DialogTitle>
            <div className='flex justify-between'>
               <div className='flex items-center gap-4'>
                  <p className='text-xl font-semibold '>{t('common.designation')}</p>
               </div>
               <GrayIconButton onClick={handleCloseDialog}>
                  <CloseIcon />
               </GrayIconButton>
            </div>
         </DialogTitle>
         <DialogContent>
            <div className='mt-4 grid grid-cols-12 items-center'>
               <label className='col-span-12' htmlFor="designationName">{t('common.name')}<span className="text-red-500">*</span></label>
               <div className='col-span-12'>
                  <CustomInput
                     inputType='text'
                     name='designationName'
                     placeholder={t('common.full-name')}
                     handleInputChange={handleInputChange}
                     value={formData.designationName}
                  />
               </div>
            </div>
            <div className='mt-4 grid grid-cols-12 items-center'>
               <label className='col-span-12' htmlFor="remark">{t('common.description')}<span className="text-red-500">*</span></label>
               <div className='col-span-12'>
                  <CustomInput
                     inputType='text'
                     name='remark'
                     placeholder={t('common.description')}
                     handleInputChange={handleInputChange}
                     value={formData.remark}
                  />

               </div>
            </div>
         </DialogContent>
         <DialogActions>
            <div className='flex gap-2 px-4 py-4'>
               <ControlpanelSecondaryButton onClick={handleCloseDialog}>
                  <p>{t('button.cancel')}</p>
               </ControlpanelSecondaryButton>
               <ControlpanelPrimaryButton onClick={handleSubmit} disabled={!formData.designationName || !formData.remark}>
                  <p>{t('button.confirm')}</p>
               </ControlpanelPrimaryButton>
            </div>
         </DialogActions>
      </CustomDialog>

   );
};

export default AddDesignationDialog;
